<template>
  <div id="basicInfo">
    <!-- 经纪人 -->
    <div class="header">
      <div class="operation-btns">
        <el-date-picker
          v-model="daterange"
          type="daterange"
          unlink-panels
          :picker-options="pickerOptions"
          :clearable="false"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="getReport"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
      </div>
      <div class="filters">
        <el-select
          v-model="query.organizationUnitId"
          @change="getReport"
          filterable
          remote
          :remote-method="remoteMethod"
          @clear="clear"
          placeholder="请输入门店名称"
          class="handle-select"
          clearable
        >
          <el-option
            v-for="item in orgList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button class="updown" plain @click="exportStatistics"
          >导出</el-button
        >
      </div>
    </div>
    <div class="main" ref="main">
      <el-table
        :data="settingsData"
        border
        show-summary
        :summary-method="getSummaries"
        @cell-click="cellClick"
        :max-height="maxHeight"
      >
        <el-table-column type="index" width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="brokerName"
          label="经纪人名称"
          align="center"
          show-overflow-tooltip
          :resizable="false"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.brokerName | nullValue }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="brokerOrganizationUnit"
          label="门店名称"
          align="center"
          show-overflow-tooltip
          :resizable="false"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.brokerOrganizationUnit | nullValue }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="reservationCount"
          label="累计报备"
          align="center"
          sortable
          :resizable="false"
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.reservationCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="visitCount"
          label="累计带看"
          align="center"
          sortable
          :resizable="false"
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.visitCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="recognitionCount"
          label="累计认购"
          align="center"
          sortable
          :resizable="false"
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.recognitionCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="netSignCount"
          label="累计网签"
          align="center"
          sortable
          :resizable="false"
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.netSignCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="累计结佣"
          align="center"
          sortable
          prop="commissionCount"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.commissionCount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="累计退订"
          align="center"
          sortable
          prop="refundCount"
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.refundCount }}
            </div>
          </template>
        </el-table-column>

        <template slot="empty">
          <div class="loading-box" v-if="isLoading">
            <img
              src="../../../../assets/image/loading.png"
              alt="loading"
              class="loading-ico"
            />
            数据加载中...
          </div>
          <div class="empty-box" v-if="!isLoading && !settingsData.length">
            列表为空
          </div>
        </template>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageIndex"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="query.maxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getBrokerStatistics,
  getExportBrokerStatistics,
} from "@/http/api/report";

import { deepCopy } from "@/utils/deepCopy";
import { getOrgsSearch } from "@/http/api/organization";
import { dateFormat } from "@/common/filters";
export default {
  data() {
    return {
      daterange: [
        new Date(
          new Date(new Date().toLocaleDateString()).getTime() -
            24 * 60 * 60 * 1000*30
        ),
        new Date(new Date(new Date().toLocaleDateString()).getTime()-1)
      ],
      pickerOptions: {
        disabledDate(time) {
          
          return (
            time.getTime()>new Date(new Date().toLocaleDateString()).getTime()-1
          ); 
        },
      },
      pageIndex:1,
      query: {
        startTime: null,
        endTime: null,
        maxResultCount: 30,
        organizationUnitId: "",
      },
      maxHeight:0,
      total:0,
      orgList: [],
      searchFilter: "",
      settingsData: [],
      isLoading: true,
      permissions:{}
    };
  },
  mounted() {
    this.permissions = this.$store.getters.permissions;
    this.getTableHeight();
    this.getReport();
  },
  methods: {
    getTableHeight () {
      this.$nextTick(() => {
        const rect = this.$refs.main.getBoundingClientRect()
        this.maxHeight = rect.height-68;
      })
    },
    cellClick(row, column){
      if (column.label!='累计结佣'&&column.label!='经纪人名称'&&column.label!='门店名称'&&column.label) {
        if (this.permissions["Reservation"]) {
          let query={
            brokerId:row.brokerId,
            brokerName:row.brokerName
          }
          switch (column.label) {
            case '累计报备':
              query.flowStatus='reservation'
              break;
            case '累计带看':
              query.flowStatus='visit'
              break;
            case '累计认购':
              query.flowStatus='recognition'
              break;
            case '累计网签':
              query.flowStatus='netSign'
              break;
          }
          if (this.daterange&&this.daterange.length) {
            query.startTime = dateFormat(this.daterange[0]);
            query.endTime = dateFormat(this.daterange[1]);
          }
          let strItem = JSON.stringify(query);
          this.$router.push({
            name:'reservationList',
            params:{
              obj:strItem,
            }
          });
        }else{
          this.$message.warning({
            message: "您暂无查看报备列表权限",
            showClose: true,
          });
        }
      }
    },
    handleSizeChange(val) {
      //console.log("更改的页面数量", val);
      this.query.maxResultCount = val;
      this.getReport();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      console.log(this.pageIndex,'this.pageIndex');
      this.getReport();
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property === "brokerName"||column.property === "brokerOrganizationUnit") {
          sums[index] = "—";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property !== "brokerName"&&column.property !== "brokerOrganizationUnit") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);

          sums[index];
        }
      });
      return sums;
    },
    remoteMethod(query) {
      if (query) {
        this.searchFilter = query;
        this.getOrgsSearch();
      }else{
        this.orgList=[];
      }
    },
    clear() {
      this.searchFilter = "";
      this.orgList=[];
    },
    // 获取分销商门店列表
    getOrgsSearch() {
      this.companies = [];
      let query = { filter: "" };
      if (this.searchFilter) {
        query.filter = this.searchFilter;
      } else {
        delete query.filter;
      }
      getOrgsSearch(query).then((res) => {
        this.orgList = res.result.items;
      });
    },
    getReport() {
      this.isLoading = true;

      if (this.daterange) {
        this.query.startTime = dateFormat(this.daterange[0]);
        this.query.endTime = dateFormat(this.daterange[1]);
      } else {
        this.query.startTime = null;
        this.query.endTime = null;
      }
      let query = deepCopy(this.query);
      query.skipCount = (this.pageIndex - 1) * this.query.maxResultCount,
      this.settingsData=[];
      getBrokerStatistics(query).then((res) => {
        if (res.code == 10200) {
          this.settingsData = res.result.items;
          this.isLoading = false;
          this.total = res.result.totalCount
        }this.isLoading = false;
      }).catch(err=>{
          this.isLoading = false;
      });
    },
    exportStatistics() {
      if (this.daterange) {
        this.query.startTime = dateFormat(this.daterange[0]);
        this.query.endTime = dateFormat(this.daterange[1]);
      } else {
        this.query.startTime = null;
        this.query.endTime = null;
      }
      let query = deepCopy(this.query);
      query.skipCount = (this.pageIndex - 1) * this.query.maxResultCount,
      getExportBrokerStatistics(query).then((res) => {
        const content = res;
        //console.log(res);
        const blob = new Blob([content]);
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = "智能报表-经纪人.xlsx";
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, "智能报表-经纪人.xlsx");
        }
      });
    }
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#basicInfo {
  .header {
    @include flex(row, center);
    justify-content: space-between;
    margin-bottom: 20px;
    border-radius: $--border-radius-base;
    .operation-btns,
    .filters {
      @include flex(row, center);
      .el-select {
        width: 200px;
        margin-left: 5px;
      }
      .input-with-select {
        width: 400px;
        .el-select {
          width: 110px;
        }
      }
      .updown {
        margin-left: 5px;
      }
    }
  }
  .pagination{
    padding: 20px;
  }

  .main{
    height: calc(100vh - 210px);
  }

  .pointer{
    cursor: pointer;
  }
}
</style>
